import axios from "axios";

const ENV_URL = process.env.REACT_APP_BACKEND_URL;

function resolveBackendUrl() {
  if (typeof window === "undefined") return ENV_URL;
  const { hostname, origin } = window.location;
  try {
    const envHost = new URL(ENV_URL).hostname;
    const strip = (h) => h.replace(/^www\./, "");
    // Same registrable host (apex vs www): stay same-origin to avoid CORS/cookie issues.
    if (envHost !== hostname && strip(envHost) === strip(hostname)) return origin;
  } catch {
    return ENV_URL;
  }
  return ENV_URL;
}

export const BACKEND_URL = resolveBackendUrl();

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

export function apiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const ROLE_LABELS = {
  super_admin: "Super Admin",
  trainer: "Trainer",
  internal_staff: "Internal Staff",
  partner: "Partner",
};

export const STATUS_LABELS = {
  not_invited: "Not invited",
  invited: "Invited",
  opened: "Opened",
  activated: "Activated",
  dormant: "Dormant",
  deleted: "Deleted",
};
